var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.86 5.216h-9.715l-1.937-2.305a.298.298 0 00-.23-.106H2.14A2.142 2.142 0 000 4.945v14.11a2.142 2.142 0 002.14 2.14h19.72a2.142 2.142 0 002.14-2.14v-11.7a2.142 2.142 0 00-2.14-2.139zm1.544 13.839a1.546 1.546 0 01-1.544 1.543H2.14a1.546 1.546 0 01-1.543-1.543V4.945A1.546 1.546 0 012.14 3.402h7.693l1.938 2.305c.057.067.14.106.229.106h9.86a1.546 1.546 0 011.544 1.543v11.699z",
    fill: "#121212"
  })));
}

export default SvgFolderBlack;